import React from 'react';
import Pagination from '@is24at/react-pagination';
import styles from './Pagination.scss';

interface LocalPaginationProps {
  initialPage: number;
  pageCount: number;
  onChange(...args: unknown[]): unknown;
}

const LocalPagination = (props: LocalPaginationProps) => {
  const { onChange, initialPage, pageCount, ...otherProps } = props;
  return (
    <section className={styles.pagination}>
      <Pagination
        initialPage={initialPage}
        pageCount={pageCount}
        onPageChange={({ selected }: any) => onChange(selected)}
        {...otherProps}
      />
    </section>
  );
};

export default LocalPagination;
